import {useQuery, gql} from '@apollo/client';
import {useMemo} from 'react';
import {GetSPPClientFiles} from '../../schema-types/GetSPPClientFiles';

export const GET_SPP_FILES = gql`
  query GetSPPClientFiles($accountId: UUID!) {
    sppClientFiles(accountId: $accountId) {
      name
      url
      createdAt
      fileType
      publishPortal
      documentType
      documentId
    }
  }
`;

const useSPPFiles = () => {
  const {
    data,
    error: sppClientFilesError,
    loading: sppClientFilesLoading,
  } = useQuery<GetSPPClientFiles>(GET_SPP_FILES, {
    variables: {
      //  do not remove this. It needs a random valid UUID to work ¯\_(ツ)_/¯
      accountId: '40463a1a-314f-11ee-be56-0242ac120002',
    },
  });

  const sppClientFiles = useMemo(() => {
    return (
      data?.sppClientFiles?.map((f) => {
        return {
          id: f.name,
          ...f,
        };
      }) || []
    );
  }, [data]);

  return {
    sppClientFiles,
    sppClientFilesError,
    sppClientFilesLoading,
  };
};

export default useSPPFiles;
